export class TradingFloorDetailModel {
  id: number | undefined
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new TradingFloorDetailModel(), obj)

    newObj.location = {
      countryId: obj.countryId,
      provinceId: obj.provinceId,
      districtId: obj.districtId,
      address: obj.address,
    }

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
